/** Locales the reports app publishes; anything else falls back to English. */
const REPORT_LANGUAGES = new Set(['pt-BR', 'es-AR', 'es-ES', 'it-IT']);

function getReportsDomain(): string {
  const isOnExplorer = globalThis.location.href.includes(
    import.meta.env.VITE_APP_CW_EXPLORER_DOMAIN
  );

  return isOnExplorer
    ? import.meta.env.VITE_APP_EXPLORER_REPORTS_URL
    : import.meta.env.VITE_APP_IMAGERY_REPORTS_URL;
}

function getReportLanguage(appLanguage: string): string {
  return REPORT_LANGUAGES.has(appLanguage) ? appLanguage : 'en';
}

function buildReportUrl({
  path,
  reportKey,
  appLanguage,
}: {
  path: string;
  reportKey: string | undefined;
  appLanguage: string;
}): string {
  return `${getReportsDomain()}/${getReportLanguage(appLanguage)}/${path}?view=${reportKey}`;
}

export { buildReportUrl };
